import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '@app/store/app.state';

export const selectServicesSlice = createFeatureSelector<AppState>('services');

export const getAllServices = createSelector(
  selectServicesSlice,
  (services: any) => services.allServices
);
